import { styled } from '@uhg-abyss/web/tools/styled';
import { Box } from '@uhg-abyss/web/ui/Box';
import { Flex } from '@uhg-abyss/web/ui/Flex';

export const ProviderDataContainer = styled(Flex, {
  padding: '12px 0px',
  width: '100%',
});

export const CareTeamCardContainer = styled(Flex, {
  width: '330px',
  borderRadius: '4px',
  padding: '0px 16px',
  gap: '24px',
  border: '1px solid $core.color.neutral.20',
  justifyContent: 'space-between',
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.12)',
  '@media (max-width: 600px)': {
    border: 'none',
    boxShadow: 'none',
    padding: '0px',
  },
});

export const CareTeamCardInnerContainer = styled(Flex, {
  overflow: 'hidden',
  alignItems: 'center',
  width: '320px !important',
  paddingLeft: '5px',
  paddingRight: '5px',
});
export const CareTeamCardHeader = styled(Flex, {
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  height: '24px',
  margin: '15px 0px 10px 0px',
});
export const CareTeamCardTitle = styled('h2', {
  fontSize: '21.25px!important',
  width: '157px',
  fontWeight: '700',
  lineHeight: '24px',
  letterSpacing: '0px',
  verticalAlign: 'bottom',
  color: '$core.color.brand.100',
  '@media (max-width: 600px)': {
    fontSize: '25.63px!important',
  },
});
export const CareTeamCardLink = styled('a', {
  color: '$core.color.brand.60',
  height: '18px',
  fontSize: '14px',
  gap: '4px',
  fontWeight: '600',
  lineHeight: '18px',
  verticalAlign: 'middle',
  letterSpacing: '0%',
  textDecoration: 'none!important',
  whiteSpace: 'nowrap',
});
export const CareTeamCardBody = styled('div', {
  alignItems: 'center',
  variants: {
    withBorder: {
      true: {
        borderBottom: '1px solid $core.color.neutral.20',
      },
      false: {
        borderBottom: 'none',
      },
    },
  },
});

export const CareTeamCardRow = styled(Box, {
  display: 'flex!important',
  backgroundColor: 'transparent !important',
  flexDirection: 'column!important',
  justifyContent: 'center!important',
  padding: '0px!important',
});

export const CareTeamProviderNameConatiner = styled('div', {
  dynamic: ({ cssProps: { isGEHAV2 } = {} }) => ({
    color: isGEHAV2
      ? '$core.color.brand.100 !important'
      : '$core.color.neutral.90 !important',
  }),
  fontSize: '14px',
  fontWeight: '700',
  lineHeight: '18px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const CareTeamProviderSpecialtyContainer = styled('div', {
  fontSize: '14px',
  margin: 0,
  color: '$core.color.neutral.90',
  fontWeight: '500',
  lineHeight: '16px',
  fontFamily: '$heading',
  letterSpacing: '0px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const CareTeamKelseySeyBoldText = styled('div', {
  fontSize: '14px',
  margin: 0,
  color: '$core.color.neutral.90',
  fontWeight: '500',
  lineHeight: '16px',
  fontFamily: '$heading',
  letterSpacing: '0px',
  whiteSpace: 'wrap',
  textOverflow: 'ellipsis',
});

export const StyledButton = styled('button', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#EEF8FB',
  color: '$core.color.brand.60',
  padding: '8px',
  borderRadius: '4px',
  flex: 1,
  border: 'none',
  fontSize: '14px',
  textAlign: 'center',
  fontWeight: '600',
  fontFamily: '$primary',
  whiteSpace: 'nowrap',
  '&:focus-visible': {
    boxShadow: '#FFF 0 0 0 2px, #196ECF 0 0 2px 4px',
  },
});

export const CareTeamButtonsCard = styled(Flex, {
  width: '330px',
  height: '48px',
  dynamic: ({ cssProps: { isGEHAV2 } = {} }) => ({
    backgroundColor: isGEHAV2 ? '#CAD9E2' : '#EEF8FB',
  }),
  display: 'flex',
  alignItems: 'center',
  border: 'none',
  marginBottom: '16px',
  borderRadius: '4px',
  justifyContent: 'center',
});

export const ProviderDetailLinkContainer = styled('a', {
  display: 'flex',
  textDecoration: 'none!important',
  width: '100%',
  variants: {
    networkStatus: {
      true: {
        cursor: 'pointer',
      },
      false: {
        cursor: 'default',
      },
    },
  },
});

export const Avatar = styled(Flex, {
  width: '32px',
  height: '32px',
  borderRadius: '50%',
  border: '1px solid $core.color.neutral.10',
  overflow: 'hidden',
});

export const CareTeamCardSkeletonLoaderBody = styled('div', {
  marginBottom: '16px',
  gap: '8px',
  padding: '8px 0',
  display: 'flex',
  alignItems: 'center',
  variants: {
    withBorder: {
      true: {
        borderBottom: '1px solid $core.color.neutral.20',
      },
      false: {
        borderBottom: 'none',
      },
    },
  },
});
